import { render, staticRenderFns } from "./modal-newsletter-success.vue?vue&type=template&id=cf60dc0a&"
import script from "./modal-newsletter-success.vue?vue&type=script&lang=js&"
export * from "./modal-newsletter-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports